var module = angular.module('bbl.services.simpleshare');

function chunk(arr, n) {
  return arr.reduce(function(p, cur, i) {
    (p[i/n|0] = p[i/n|0] || []).push(cur);
    return p;
  },[]);
}

module.factory('simpleChat', ['connect', 'pubsub', function(connect, pubsub) {
  var types = {
    CONNECTED: 'smpl.chat.connected',
    DISCONNECTED: 'smpl.chat.disconnected',
    ONREPLY: 'smpl.chat.onreply',
  };

  var dataChannels = {};

  return function(user, room) {
    if (dataChannels[room]) {
      return dataChannels[room];
    }

    var conn = connect(room, user),
      peerCh = {},
      messages = [],
      uniq = {};

    conn.createDataChannel(room+'-chat')
      .on('channel:opened:'+room+'-chat', register)
      .on('channel:closed:'+room+'-chat', unRegister);

    function register(id, dc) {
      (peerCh[id] = dc).onmessage = onPeerMessage;

      if(messages.length) {
        sendBatch(messages, dc);
      }

      pubsub.pub(types.CONNECTED, conn.peers.get(id).data.user);
    }

    function unRegister(id) {
      peerCh[id] = undefined;
      pubsub.pub(types.DISCONNECTED, conn.peers.get(id).data.user);
    }

    function onPeerMessage(evt) {
      var data = JSON.parse(evt.data);

      if(data.type === 'reply') {
        pushReply(data.data);
      }

      if(data.type === 'batch') {
        data.data.forEach(pushReply);
      }
    }

    function pushReply(reply) {
      if(uniq[reply.id]) {
        return;
      }

      uniq[reply.id] = messages = messages.concat(reply).sort(function(a, b) {
        return a.timestamp - b.timestamp;
      });

      pubsub.pub(types.ONREPLY, messages);
    }

    function sendReply(text) {
      var reply = {
        id: conn.id + ':' + Date.now(),
        author: user.username,
        text: text,
        timestamp: Date.now(),
      };

      var msg = __send('reply', reply);
      onPeerMessage({data: msg});
    }

    function sendBatch(batch, peer) {
      chunk(batch.slice(-999).reverse(), 50).forEach(function(_chunk) {
        __send('batch', _chunk);
      });
    }

    function __send(type, data, peer) {
      var msg = JSON.stringify({type: type, data: data});

      if(!peer) {
        conn.peers.keys()
          .filter(function(peer) { return !!peerCh[peer]; })
          .forEach(function(peer) {
            try {peerCh[peer].send(msg);} catch(e) {
              console.warn('peer invalid state, cant send message!');
            }
          });
      } else {
        peer.send(msg);
      }

      return msg;
    }

    return (dataChannels[room] = {
      send: sendReply,
      sub: pubsub.sub.bind(pubsub),
      types: types,
    });
  };
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/simpleshare/chat.service.js
 ** module id = 225
 ** module chunks = 0
 **/